export default __webpack_public_path__ + "images/U6.ba78778.png";